import { render, staticRenderFns } from "./DictionaryField.vue?vue&type=template&id=5d62d3a1&scoped=true&"
import script from "./DictionaryField.vue?vue&type=script&lang=js&"
export * from "./DictionaryField.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryField.vue?vue&type=style&index=0&id=5d62d3a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d62d3a1",
  null
  
)

export default component.exports